var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotScanArea = function SvgHotspotScanArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m5.146 12.09 6.773-6.774a.5.5 0 0 1 .354-.146H18.5a.5.5 0 0 1 .5.5v6.227a.5.5 0 0 1-.146.354l-6.773 6.772a.5.5 0 0 1-.354.147H5.5a.5.5 0 0 1-.5-.5v-6.227a.5.5 0 0 1 .146-.354Z"
  })));
};
export default SvgHotspotScanArea;